import "@/assets/styles/base.css";

import React, { useEffect, useRef, useState } from "react";
import SpinLoding from "./components/SpinLoding";
import AsyncSpinLoding from "./components/AsyncSpinLoding";
import { Router, Route, Switch } from "react-router-dom";
import history from "./utils/history";
import landtipImg from "@/assets/img/M/landtip.png";

// 使用 React.lazy 懒加载页面
const A1HomeM = React.lazy(() => import("./pages/A1HomeM"));
const A2GoodsM = React.lazy(() => import("./pages/A2GoodsM"));

const NotFound = React.lazy(() => import("@/components/NotFound"));

function App() {
  const timeRef = useRef(-1);

  // 屏幕高度
  const [scrH, setScrH] = useState(window.innerHeight);

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        clearTimeout(timeRef.current);
        timeRef.current = window.setTimeout(() => {
          setScrH(window.innerHeight);
        }, 500);
      },
      true
    );
  }, []);
  return (
    <div id="appM" style={{ height: scrH }}>
      {/* 关于路由 */}
      <Router history={history}>
        <React.Suspense fallback={<SpinLoding />}>
          <Switch>
            {/* 封面页 */}
            <Route path="/" exact component={A1HomeM} />
            <Route path="/goods" component={A2GoodsM} />

            {/* 找不到页面 */}
            <Route path="*" component={NotFound} />
          </Switch>
        </React.Suspense>
      </Router>

      {/* 发送请求的加载组件 */}
      <AsyncSpinLoding />

      {/* 竖屏浏览 */}
      <div className="SscrHBox">
        <img src={landtipImg} alt="" />
        <p>请竖屏浏览</p>
      </div>
    </div>
  );
}

const MemoApp = React.memo(App);

export default MemoApp;
